module.exports = __webpack_public_path__ + "img/bn.1d197411.svg";